import Close16 from '@carbon/icons-react/es/close/16';
import { camelCase } from 'lodash';
import React, { FC, useEffect, useRef, useState } from 'react';
import { FinancialsProjectSettings } from 'api/project';
import { Button } from 'components/atoms/button';
// import { currencyRenderer } from 'components/atoms/currency-renderer';
import {
  CustomLayoutDrawer,
  CustomLayoutDrawerContent,
} from 'components/atoms/drawer';
import { Form } from 'components/atoms/form';
import { InputNumber } from 'components/atoms/input';
// import { hoursFormatter } from 'components/organisms/projects/project-financials/components';
import { TranslationKey, useTranslate } from 'hooks/use-translation';
// import { useAccountProfile } from 'queries/account';
import { EditBudgetAndRateTypes } from './edit-fields-drawer';
import { ButtonWrapper } from './styles';

const getEditField = (type: EditBudgetAndRateTypes) => {
  return type === EditBudgetAndRateTypes.FixedFee
    ? camelCase(EditBudgetAndRateTypes.ProjectBudget)
    : camelCase(type);
};

interface InputNumberRef {
  focus: () => void;
}

export const SimpleEditDrawer: FC<{
  data: FinancialsProjectSettings | undefined;
  type: EditBudgetAndRateTypes;
  visible: boolean;
  saveInProgress: boolean;
  onClose: () => void;
  onSave: (financialsProjectSettings: FinancialsProjectSettings) => void;
}> = ({ type, visible, onClose, onSave, data, saveInProgress }) => {
  const translate = useTranslate();
  // const { data: account } = useAccountProfile();
  const [value, setValue] = useState<number | undefined>();
  const fieldIntialVal = data?.[getEditField(type)];
  const inputRef = useRef<InputNumberRef>(null);

  useEffect(() => {
    setValue(fieldIntialVal);
  }, [fieldIntialVal]);

  // const formatter = (val, editType: EditBudgetAndRateTypes) => {
  //   return EditBudgetAndRateTypes.ProjectHours === editType
  //     ? hoursFormatter({ value: val * 60 })
  //     : currencyRenderer(val, account?.currency.currencyCode);
  // };

  const setFocus = (isOpen: boolean) => {
    if (isOpen) {
      inputRef.current?.focus();
    }
  };

  return (
    <CustomLayoutDrawer
      destroyOnClose
      width={360}
      visible={visible}
      closeIcon={<Close16 />}
      onClose={onClose}
      afterVisibleChange={setFocus}
    >
      <CustomLayoutDrawerContent>
        <CustomLayoutDrawerContent.Title>
          {translate(
            `project.settings.budget.rate.edit.${type}.title` as TranslationKey,
          )}
        </CustomLayoutDrawerContent.Title>
        <CustomLayoutDrawerContent.Content>
          <Form layout="vertical">
            <Form.Item
              label={translate(
                `project.settings.budget.rate.edit.${type}.input` as TranslationKey,
              )}
            >
              {/* <InputNumber
                value={value}
                min={0}
                onChange={(e) => setValue(e as number)}
              /> */}
              <InputNumber
                min={0}
                ref={inputRef}
                value={value}
                onChange={(e) => setValue(e as number)}
              />
            </Form.Item>
          </Form>
        </CustomLayoutDrawerContent.Content>
        <CustomLayoutDrawerContent.Footer>
          <ButtonWrapper>
            <Button onClick={onClose} type="default">
              {translate('cancel')}
            </Button>
            <Button
              loading={saveInProgress}
              disabled={!data || data?.[getEditField(type)] === value}
              onClick={() => {
                if (data) {
                  onSave({
                    ...data,
                    [getEditField(type)]: value,
                  });
                }
              }}
              type="primary"
            >
              {translate('save')}
            </Button>
          </ButtonWrapper>
        </CustomLayoutDrawerContent.Footer>
      </CustomLayoutDrawerContent>
    </CustomLayoutDrawer>
  );
};
